import { env } from "../datas.config";
import { socket } from "./socket";

export async function sendMessageFileGroupe(object, formData, msgForSocket, workspaceId) {
  let status = "";
  try {
    const res = await fetch(
      `${env.domain}/api/auth/uploads/conversations/conversation/upload-file/${object.roomId}`,
      {
        method: "post",
        body: formData,
        credentials: "include",
      }
    );
    const data = await res.json();
    socket.emit("send_message_groupe_file", { ...msgForSocket, workspaceId });
    status = data.sms.status;
  } catch (erreur) {
    console.clear();
    console.error(erreur);
  } finally {
    return status;
  }
}

export const getFileSize = (file) => {
  const sizeInBytes = file;
  const units = ["Octets", "Ko", "Mo"];
  let size = sizeInBytes;
  let unitIndex = 0;
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }
  return `${size.toFixed(2)} ${units[unitIndex]}`;
};

export async function sendSmsVocal(object, formData, workspaceId) {
  let status = "";
  try {
    const res = await fetch(
      `${env.domain}/api/auth/uploads/conversations/conversation/message-vocal/${object.roomId}`,
      {
        method: "post",
        body: formData,
        credentials: "include",
      }
    );
    const data = await res.json();
    socket.emit("sendMsgInbox", { ...object, workspaceId });
    socket.emit("vaChercherLaConversation", object.roomId, workspaceId);
    status = data.sms.status;
  } catch (erreur) {
    console.clear();
    console.error(erreur);
  } finally {
    return status;
  }
}

export async function sendMessageGroupe(object, workspaceId) {
  socket.emit("sendMsgGroupe", {
    canal: object.roomId,
    timeUnix: Date.now(),
    ...object,
    workspaceId,
  });
}

export const sendMessageAccessCodeGroupe = ({ roomId, membres, user, accessCode, workspaceId }) => {
  socket.emit("sendMsgGroupe", {
    emetteur: user.userId,
    destinataire: membres,
    contenu: accessCode,
    nature: "code_meeting",
    roomId,
    canal: roomId,
    timeUnix: Date.now(),
    workspaceId,
  });
};

export const jeSupprimeLeMessageDeGroupe = (
  emetteur,
  destinataires,
  messageId,
  roomId,
  workspaceId
) => {
  socket.emit("je_supprime_le_message_groupe", {
    messageId,
    emetteur,
    destinataires,
    roomId,
    workspaceId,
  });
};

export const supprimerTousEnGroupe = (
  roomId,
  emetteur,
  interlocuteurs,
  membres,
  workspaceId
) => {
  socket.emit("je_supprime_tous_les_messages_groupe", {
    roomId,
    emetteur,
    interlocuteurs,
    membres,
    workspaceId,
  });
};
